import React from 'react';
import DownloadFallback from './DownloadFallback';

const APP_SCHEME = 'zwyk://';

const buildDeepLink = (): string => {
  if (typeof window === 'undefined') return APP_SCHEME;

  const { pathname, search, hash } = window.location;
  const path = pathname.replace(/^\/app\/?/, '');

  return `${APP_SCHEME}${path}${search}${hash}`;
};

const AppLinkFallback: React.FC = () => {
  return <DownloadFallback deepLink={buildDeepLink()} />;
};

export default AppLinkFallback;
